<template>
  <div>
    <div class="tab-pane slide-left active">
      <div class="row column-seperation">
        <div class="col-md-12">
          <div class="title">
            <h3 v-if="mailWithdrawalProxies.length"> Voici les personnes qui ont le pouvoir courrier:</h3>
            <h3 v-else>Aucun pouvoir courrier:</h3>
            <button class="btn btn-complete"
                    v-show="!editing && !contract.terminated"
                    @click="editing = true">Ajouter</button>
          </div>
          <div class="m-t-20"
               @keyup.esc="resetNewItem">
            <item v-for="(proxy, idx) in mailWithdrawalProxies"
                  :key="'mail-proxy-'+idx"
                  :proxy="proxy"
                  :contract="contract"
                  @remove="removeMailWithdrawalProxy(proxy)"></item>
            <new-item v-if="editing"
                      v-model="newMailWithDrawalProxy.recipient_name"
                      @add="handleNewMailWithDrawalProxy"
                      @cancel="resetNewItem">
            </new-item>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>

</style>

<script type="text/babel">
  import Item from './PersonnalPostalProxy/Item'
  import NewItem from './PersonnalPostalProxy/NewItem'
  import { mapState, mapActions } from 'vuex'

  export default {
    name: 'PersonnalPostalProxy',
    components: {
      Item,
      NewItem,
    },

    data () {
      return {
        newMailWithDrawalProxy: {
          recipient_name: ""
        },
        editing: false
      }
    },

    computed: {
        ...mapState('contract', [
            'mailWithdrawalProxies'
        ]),
        ...mapState('contract', {
            contract: 'model'
        })
    },

    methods: {
      ...mapActions('contract', [
        'addMailWithdrawalProxy',
        'removeMailWithdrawalProxy',
      ]),

      resetNewItem () {
        this.newMailWithDrawalProxy.name = ""
        this.editing = false
      },

      handleNewMailWithDrawalProxy () {
        this.$store.commit('FORM_ERROR', {})
        this.addMailWithdrawalProxy(this.newMailWithDrawalProxy)
          .then(this.resetNewItem)
      },
    }
  }
</script>



// WEBPACK FOOTER //
// client/components/Customer/ContractManagementContent/PersonnalPostalProxy.vue